export default "__VITE_ASSET__C$hb3Wla__"